/*!
=========================================================
* Muse Ant Design Dashboard - v1.0.0
=========================================================
* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { initializeErrorSuppression } from "./utils/errorSuppression";

import "./assets/styles/variables.css";
import "./assets/styles/common.css";

// Initialize error suppression before React starts
initializeErrorSuppression();

// Disable React error overlay for ResizeObserver errors in development
if (process.env.NODE_ENV === "development") {
  const originalConsoleError = console.error;
  console.error = (...args) => {
    // Check if this is a ResizeObserver error
    const isResizeObserverError = args.some(
      (arg) =>
        typeof arg === "string" &&
        arg.includes(
          "ResizeObserver loop completed with undelivered notifications"
        )
    );

    if (isResizeObserverError) {
      return; // Completely suppress
    }

    originalConsoleError.apply(console, args);
  };

  // Also patch the React error overlay
  // eslint-disable-next-line no-unused-vars
  const showErrorOverlay = (err) => {
    if (
      err &&
      err.message &&
      err.message.includes("ResizeObserver loop completed")
    ) {
      return; // Don't show overlay for ResizeObserver errors
    }
    // For other errors, you might want to show them or handle differently
  };

  window.addEventListener(
    "error",
    (event) => {
      if (
        event.message &&
        event.message.includes("ResizeObserver loop completed")
      ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
      }
    },
    true
  );
}

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
